module.exports = __webpack_public_path__ + "img/deco_wave.ff7203dc.svg";